<template>

    <div class="page">

        <div class="fetch">
            <div></div>
            <div class="middle">

                <div class="bloc">

                    <lottie-foxy-wink :loop="true" :autoplay="true" class="foxy"></lottie-foxy-wink>

                    <div class="fetching" v-if="isProcessing">
                        <lottie-loader :size="24"></lottie-loader>
                        <p class="scan">{{ $t('partial_fetch_scan_in_progress') }}</p>
                        <p class="title">{{ $t('partial_fetch_dont_close') }}</p>
                        <p class="text">{{ $t('partial_fetch_start_second') }}</p>
                    </div>
                    <div class="partial" v-if="isSortable">
                        <lottie-loader :size="24"></lottie-loader>
                        <p class="scan">{{ $t('partial_fetch_scan_in_progress') }}</p>
                        <p class="close">{{ $t('partial_fetch_dont_close') }}</p>
                        <div class="container">
                            <div class="divider"></div>
                        </div>
                        <p class="title">{{ $t('partial_fetch_preview_ready') }}</p>
                        <markdown class="text"
                                  :text=" $tc('partial_fetch_preview_ready_subtilte', newslettersTemp.length, {'nb_partial': newslettersTemp.length})"></markdown>
                        <button @click="goClean">{{ $t('partial_fetch_preview_cta') }}</button>
                    </div>
                    <div class="done" v-if="isFetchDone">
                        <div class="round">
                            <img src="/img/icons/check-white.svg">
                        </div>
                        <p class="title">{{ $t('partial_fetch_scan_done_title') }}</p>
                        <p class="text">{{ $t('partial_fetch_scan_done_subtitle') }}</p>
                        <button @click="goClean">{{ $t('partial_fetch_scan_done_cta') }}</button>
                    </div>
                </div>
            </div>
            <div class="footer">
                <notifications-ask-bloc></notifications-ask-bloc>
                <button class="settings" @click="goSettings">{{ $t('partial_fetch_settings') }}</button>
            </div>
        </div>
    </div>

</template>

<script>
import Vuex from 'vuex'

import Api from '../api'

import ENUM from '../assets/ENUM'

import I18n from '../modules/i18n'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import CheckboxCircle from '../components/inputs/CheckboxCircle'
import LottieLoader from '../components/lottie/LottieLoader'
import LottieCheck from '../components/lottie/LottieCheck'
import LottieFoxyWink from '../components/lottie/LottieFoxyWink'
import Markdown from '../components/Markdown'
import NotificationsAskBloc from '../components/NotificationsAskBloc'
import ScrollingSenders from '../components/ScrollingSenders.vue'
import TipsFetch from '../components/TipsFetch'

export default {

    name: 'fetch-express',

    components: {
        CheckboxCircle,
        LottieLoader,
        LottieCheck,
        LottieFoxyWink,
        Markdown,
        NotificationsAskBloc,
        ScrollingSenders,
        TipsFetch
    },

    watch: {
        fetchStatus() {
            if (this.isFetchDone) {
                Tag.pageViewAll(this, 'fetch_done')

                if (this.newsletters.length === 0 && !this.newslettersWaiting) {
                    this.$router.push({path: '/fetch-and-empty'})
                }
            }
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'enoughNewsletters',
            'newsletters',
            'newslettersBus',
            'newslettersWaiting',
            'newslettersTemp',
            'fetchStatus'
        ]),

        isProcessing() {
            return !this.isFetchDone && !this.isSortable
        },

        isFetchDone() {
            return this.fetchStatus === ENUM.FETCH_STATUS.DONE
        },

        isSortable() {
            return this.fetchStatus !== ENUM.FETCH_STATUS.DONE && this.enoughNewsletters
        }
    },

    mounted() {
        Tag.pageViewGA(this, 'fetch')
        UserFlow.setPage(this, 'fetch')

        this.notifEmailLanguage()
        this.refreshNewsletters()
    },

    methods: {

        ...Vuex.mapActions([
            'refreshNewsletters',
            'updateFetchEndNotif',
            'updateNewsletters'
        ]),

        async goClean() {
            Tag.clickGA(this, 'next')
            await this.updateNewsletters()
            this.$router.push({path: '/newsletters'})
                .catch(() => {
                })
        },

        goSettings() {
            Tag.clickGA(this, 'settings')
            this.$router.push({path: '/settings'})
        },

        notifEmailLanguage() {
            Api.user.updateFetchLanguage(I18n.get(this))
                .catch(() => {
                })
        }
    }
}
</script>

<style lang="scss" scoped>

.page {

    .fetch {
        padding: 24px 16px 16px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-image: url("/img/fetch/illustration-fetch-background-mobile.svg");
        background-size: cover;
        background-position: bottom;
        background-color: $aquamarine;
        @media screen and (min-width: $above-tablet-length) {
            background-image: url("/img/fetch/illustration-fetch-desktop.svg");
        }

        .middle {
            display: flex;
            align-items: center;
            justify-content: center;

            .bloc {
                width: 100%;
                position: relative;
                padding: 24px 16px 24px;
                background-color: $white;
                border-radius: 12px;
                display: flex;
                flex-direction: column;
                align-items: center;
                @media screen and (min-width: $above-tablet-length) {
                    max-width: 420px;
                }

                .foxy {
                    width: 200px;
                    top: -125px;
                    position: absolute;
                }

                > div {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .title {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 28px;
                    @media screen and (min-width: $above-tablet-length) {
                        font-size: 24px;
                        font-weight: 600;
                    }
                }

                .text {
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 20px;
                    @media screen and (min-width: $above-tablet-length) {
                        font-size: 17px;
                        font-weight: 400;
                        line-height: 24px
                    }
                }

                .fetching {
                    .scan {
                        margin-top: 16px;
                        color: $neutralsMoon;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 16px;
                        @media screen and (min-width: $above-tablet-length) {
                            font-size: 15px;
                            line-height: 20px;
                        }
                    }

                    .title {

                    }

                    .text {
                        margin-top: 16px;
                        color: $neutralsMoon;
                    }
                }

                .partial {
                    .scan {
                        margin-top: 16px;
                        color: $neutralsMoon;
                        font-size: 15px;
                        font-weight: 400;
                        line-height: 20px;
                    }

                    .close {
                        color: $neutralsMoon;
                        font-size: 15px;
                        font-weight: 600;
                        line-height: 20px;
                    }

                    .container {
                        margin-top: 16px;
                        position: relative;
                        width: 100%;

                        .divider {
                            position: absolute;
                            top: 0;
                            left: -16px;
                            right: -16px;
                            height: 1px;
                            background-color: #D7D9DF;
                        }
                    }

                    .title {
                        margin-top: 16px;
                    }

                    .text {
                        margin-top: 8px;
                        color: $neutralsMoon;
                    }

                    > button {
                        margin-top: 16px;
                        padding: 8px 16px;
                        background-color: $aquamarine;
                        border-radius: 32px;
                        color: $white;
                        font-size: 17px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 24px;
                    }
                }

                .done {

                    .round {
                        width: 40px;
                        height: 40px;
                        border-radius: 100%;
                        background-color: $aquamarine;
                        display: flex;
                        justify-content: center;
                        align-items: center;


                        > img {
                            width: 24px;
                            object-fit: contain;
                        }
                    }

                    .title {
                        margin-top: 16px;
                    }

                    .text {
                        margin-top: 8px;
                    }

                    > button {
                        margin-top: 16px;
                        width: 100%;
                        padding: 16px;
                        border-radius: 32px;
                        background-color: $midnight;
                        font-size: 17px;
                        font-weight: 600;
                        line-height: 24px;
                        color: $white;
                    }
                }
            }

        }

        .footer {
            display: flex;
            flex-direction: column;
            align-items: center;

            .settings {
                margin-top: 16px;
                padding: 8px 16px;
                background-color: transparent;
                font-size: 17px;
                font-weight: 600;
                line-height: 24px;
            }
        }

    }
}

</style>
